<!--#region bouton planning selon bureau-->
<div class="mx-2 w-100 row align-items-center mt-2 q-bold">
  <button class="col-auto q-btn q-main" (click)="OnImport()">Planning selon bureau</button>
</div>
<!--#endregion-->

<!--#region dates de début et de fin-->
<div class="mx-2 w-100 row align-items-center mt-2 q-bold">
  <span>Du</span>
  <q-date  class="mx-2" style="width: 150px;" [(ngValue)]="planningService.DateDebut"></q-date>
  <span class="mx-2" >au</span>
  <q-date style=" width: 150px;" [(ngValue)]="planningService.DateFin"></q-date>
</div>
<!--#endregion-->

<!--#region constructeur pour le découpage-->
<fieldset class="mt-2 q-fieldset w-100 mb-4" style="min-height:331px; height: auto;">

  <!--#region ouverture du bo reservation-->
  <div class="row m-2 justify-content-end">
    <div class="d-flex align-items-end q-pointer q-text-s" (click)="open(ModalBO)">Réservation /Personnalisation<i class="fas fa-edit q-c-main ml-2"></i></div>
  </div>
  <!--#endregion-->

  <!--#region liste des modes de découpage-->
  <div class="row m-2">
    <ng-container *ngFor="let dailyMode of DailyModeList">
      <button class="q-btn col-auto" [ngClass]="[dailyMode.Selected ? 'q-light-main' : 'q-white']" (click)="OnClickDailyMode(dailyMode)">{{dailyMode.Title}}</button>
    </ng-container>
  </div>
  <!--#endregion-->

  <!--#region jours de la semaine-->
  <div class="row m-2">
    <ng-container *ngFor="let day of DaysList">
      <button class="q-btn col-auto px-2" [disabled]="DailyModeList[3].Selected" [ngClass]="[day.Selected && !DailyModeList[3].Selected ? 'q-light-main' : 'q-white']" (click)="day.Selected = !day.Selected">{{day.Title}}</button>
    </ng-container>
  </div>
  <!--#endregion-->

  <!--#region bloc heures pour le découpage Matin-->
  <div *ngIf="DailyModeList[0].Selected" class="row m-2 align-items-center">
    Matin:
    <input class="mx-1" type="time" name="AMFrom" [(ngModel)]="AMFrom" (blur)="CalculDuree(AMFrom, AMTo, 'AM'); CalculDuree(AMFrom, PMTo, 'DAY');" />
    à
    <input class="mx-1" type="time" name="AMTo" [(ngModel)]="AMTo" (blur)="CalculDuree(AMFrom, AMTo, 'AM')" />
    Durée
    <input class="mx-1" type="time" name="AMDuration" [(ngModel)]="AMDuration" />
  </div>
  <!--#endregion-->
  <!--#region bloc heures pour le découpage après midi-->
  <div *ngIf="DailyModeList[1].Selected" class="row m-2 align-items-center">
    Après Midi:
    <input class="mx-1" type="time" name="PMFrom" [(ngModel)]="PMFrom" (blur)="CalculDuree(PMFrom, PMTo, 'PM')" />
    à
    <input class="mx-1" type="time" name="PMTo" [(ngModel)]="PMTo" (blur)="CalculDuree(PMFrom, PMTo, 'PM');  CalculDuree(AMFrom, PMTo, 'DAY');" />
    Durée
    <input class="mx-1" type="time" name="PMDuration" [(ngModel)]="PMDuration" />
  </div>
  <!--#endregion-->
  <!--#region bloc heures pour le découpage journée ou intervalle-->
  <div *ngIf="DailyModeList[2].Selected || DailyModeList[3].Selected" class="row m-2 align-items-center">
    De
    <input class="mx-1" type="time" name="AMFrom" [(ngModel)]="AMFrom" (blur)="CalculDuree(AMFrom, AMTo, 'AM'); CalculDuree(AMFrom, PMTo, 'DAY');" />
    à
    <input class="mx-1" type="time" name="PMTo" [(ngModel)]="PMTo" (blur)="CalculDuree(PMFrom, PMTo, 'PM'); CalculDuree(AMFrom, PMTo, 'DAY');" />
    Durée
    <!--input pour journée-->
    <input *ngIf="DailyModeList[2].Selected" class="row m-2" type="time" name="DayDuration" [(ngModel)]="DayDuration" />

    <!--input pour intervalle (heures pouvant dépasser la limite des 24 heures imposées par un input type="time")-->
    <div *ngIf="DailyModeList[3].Selected" class="range-time row m-2">
      <input type="number" min="0" name="RangeDurationHour" [(ngModel)]="RangeDurationHour" style="max-width: 40px; min-width: 25px; width: auto;" />
      :
      <input type="text" pattern="\d*" name="RangeDurationMin" [ngModel]="RangeDurationMin" (ngModelChange)="OnRangeDurationMinChange($event)" (blur)="OnBlurRangeDurationMin($event.target.value)" style="width: 25px;" />
    </div>
  </div>
  <!--#endregion-->

  <!--#region formateurs-->
  <div class="row m-2 align-items-center">
    Formateurs:
    <q-avatar-search class="ml-2" mode="FORMATEUR" [multipleSelection]="true" [getSelectedListOnInit]="true" (selectedList)="OnFormateurSelect($event)" [value]="formateursSurStage"></q-avatar-search>
  </div>
  <!--#endregion-->

  <!--#region salles-->
  <div class="row m-2 align-items-center">
    Réservation d'objets :
    <button class="selected-element-container ml-2 q-pointer"
            [ngClass]="{'empty-objects': !AnyObjectSelected()}"
            popoverClass="popover-size"
            [ngbPopover]="f1"
            [placement]="['top', 'auto']"
            [autoClose]="'outside'"
            container="body"
            #p1="ngbPopover">
      <i class="fas fa-desktop"></i>
    </button>
  </div>
  <!--#endregion-->

  <!--#region bureaux-->
  <div class="row m-2 align-items-center">
    Bureau:
    <select class="ml-2 q-main-select col-auto" [(ngModel)]="IdBureau" style="max-width: 100%; text-overflow: ellipsis; white-space: nowrap;">
      <option *ngFor="let bureau of planningService.ListeBureaux" [value]="bureau.id">{{bureau.value}}</option>
    </select>
  </div>
  <!--#endregion-->

  <!--#region lieu-->
  <div class="row m-2 align-items-center">
    Lieu:
    <select class="ml-2 q-main-select col-auto" [(ngModel)]="IdLieu" style="max-width: 100%; text-overflow: ellipsis; white-space: nowrap;">
      <option *ngFor="let lieu of planningService.ListeLieux" [value]="lieu.id">{{lieu.value}}</option>
    </select>
  </div>
  <!--#endregion-->

  <!--#region bouton de découpage-->
  <div class="row m-2 align-items-center">
    <button class="q-btn q-main" [disabled]="!CanSave() || isLoading" (click)="OnSave()">Appliquer le découpage</button>
    <i *ngIf="isLoading" class="fas fa-spin fa-spinner fa-pulse q-c-main"></i>
  </div>
  <!--#endregion-->

</fieldset>
<!--#endregion-->

<!--#region popover pour les objets (salles)-->
<ng-template #f1>
  <div class="w-100">
    <ng-container *ngFor="let groupe of objects?.Children">
      <div class="w-100 q-c-main">
        <strong>{{groupe.Text}} :</strong>
      </div>
      <ng-container *ngFor="let object of groupe.Children">
        <div class="row px-2 q-pointer" style="margin-left: -10px; margin-right: -10px;" [ngClass]="[object.IsChecked ? 'q-bold q-hover' : 'q-light-hover']"
             [title]="(object.IsChecked ? 'Retirer' : 'Ajouter') + ' ' + object.Text"
             (click)="moveItem(groupe, object)">
          <span>{{object.Text}}</span>
          <span [ngClass]="{'invisible': !object.IsChecked}" class="fa-stack q-c-main fa-xs q-btn-partdelete float-right ml-auto" title="retirer le collaborateur">
            <i class="fas fa-circle fa-stack-2x"></i>
            <i class="fas fa-check fa-stack-1x fa-inverse"></i>
          </span>
        </div>
      </ng-container>
    </ng-container>
  </div>
</ng-template>
<!--#endregion-->

<!-- Modals BO -->
<ng-template #ModalBO class="modal-dialog-centered" let-modalBO>
  <div class="modal-header">

    <button type="button" class="close d-flex justify-content-end" (click)="modalBO.dismiss('CANCEL')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <button class="q-btn q-main q-btn-save-custom" (click)="OnGetBo(bodisplay.model, modalBO)"><i class="fas fa-save"></i></button>
    <q-bodisplay #bodisplay class="w-100 h-100 mb-5" [param]="boParam" (sendBoReady)="OnGetBo($event)"></q-bodisplay>
  </div>
</ng-template>
